module.exports = require('./dist/bundle.js');




//////////////////
// WEBPACK FOOTER
// ./node_modules/re-base/index.js
// module id = 187
// module chunks = 0